/* eslint-disable no-console */
import ApplicationConf from 'conf/ApplicationConf'
import { toast } from 'react-toastify'
import { createAppSlice } from 'common/createAppSlice'
import { aquaFetch } from 'common/utils/ActionUtils'
import { STATUS } from 'common/constants/storeConstants'

const initialState = {
    status: STATUS.IDLE,
    allClientNotes: [],
}

const NotesSlice = createAppSlice({
    name: 'gdl/notes',
    initialState,
    reducers: (create) => ({
        reset: create.reducer(() => initialState),

        createNote: create.asyncThunk(
            async (note, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.gdl.notes(), { body: note, method: 'POST' })
                    toast.success('Note créée avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la création d\'une note')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            },
        ),
        updateNote: create.asyncThunk(
            async (note, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.gdl.notes(), { body: note, method: 'PUT' })
                    toast.success('Note modifiée avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la modification d\'une note')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            },
        ),
        deleteNote: create.asyncThunk(
            async (id, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.gdl.note(id), { method: 'DELETE' })
                    toast.success('Note supprimée avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la suppression d\'une note')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            },
        ),
        fetchCustomerNotes: create.asyncThunk(
            async (idClient, { rejectWithValue }) => {
                try {
                    return await aquaFetch(ApplicationConf.gdl.customerNotes(idClient))
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors du chargement des notes du client')
                    return rejectWithValue(err)
                }
            },
            {
                pending: state => {
                    state.status = STATUS.LOADING
                },
                rejected: state => {
                    state.status = STATUS.REJECTED
                },
                fulfilled: (state, action) => {
                    state.status = STATUS.SUCCEEDED
                    state.allClientNotes = action.payload
                },
                options: {
                    condition: (_, { getState }) => {
                        const { gdl } = getState()
                        return gdl.notes.status === STATUS.IDLE
                    },
                    dispatchConditionRejected: true,
                },
            },
        ),
    }),
})

export const { fetchCustomerNotes, updateNote, createNote, deleteNote } = NotesSlice.actions

export default NotesSlice